import styled from 'styled-components';

export const Body = styled.section`
  min-height: 100vh;
  margin: 0;
  line-height: 100%;
  display: grid !important;
  grid-template-rows: auto 1fr auto;
`;
